const authOptions = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  OIDC: 'OIDC'
};

module.exports = {
  authOptions
};
